import type { LocaleCatalogShape } from '@/shared/i18n'
import type { emojiPickerEn, guildSelectorEn, languageSelectorEn, appDrawerEn } from './en.ts'

export const languageSelectorRu: LocaleCatalogShape<typeof languageSelectorEn> = {
  label: 'Язык интерфейса',
  options: {
    automatic: 'Автоматически',
    en: 'Английский',
    ru: 'Русский',
  },
  automaticDescription: 'Автоматически · язык гильдии, затем браузера',
}

export const emojiPickerRu: LocaleCatalogShape<typeof emojiPickerEn> = {
  chooseEmoji: 'Выберите эмодзи',
  insertEmoji: 'Вставить эмодзи',
  insert: (emoji: string) => `Вставить ${emoji}`,
}

export const guildSelectorRu: LocaleCatalogShape<typeof guildSelectorEn> = {
  activeGuild: 'Активная гильдия',
  switchGuild: 'Сменить гильдию',
  restrictedGuilds: 'Гильдии с ограничениями',
  loadingGuilds: 'Загрузка гильдий…',
  noGuilds: 'Нет доступных гильдий.',
  addBot: 'Добавить бота на сервер Discord',
  preparingBotInvite: 'Подготовка приглашения бота…',
  botInviteFailed: 'Приглашение бота недоступно.',
  guildAccessRequired: 'Требуется доступ к гильдии',
  selectGuild: 'Выберите гильдию',
  requestGuildAccess: 'Запросить доступ к гильдии',
  selectActiveGuild: 'Выберите активную гильдию',
  activeGuildLabel: (name: string) => `Активная гильдия: ${name}`,
  available: (count: number) => `Доступно: ${count}`,
  availableAndRestricted: (available: number, restricted: number) =>
    `Доступно: ${available} · С ограничениями: ${restricted}`,
  roles: {
    owner: 'Владелец',
    officer: 'Офицер',
    member: 'Участник',
  },
  access: {
    boardEditingEnabled: 'Доступно редактирование доски',
    viewOnly: 'Только просмотр',
    requestPending: 'Запрос доступа ожидает обработки',
    discordRoleRequired: 'Для просмотра нужна роль Discord',
  },
  request: {
    pending: 'Ожидает',
    requesting: 'Запрос…',
    requestAccess: 'Запросить доступ',
  },
}

export const appDrawerRu: LocaleCatalogShape<typeof appDrawerEn> = {
  close: 'Закрыть',
  closeTitle: (title: string) => `Закрыть: ${title}`,
}
